import lightFormat from 'date-fns/lightFormat'

export function customRouteOrderingId(day: Date) {
  return lightFormat(day, 'yyyy-MM-dd')
}
